import { FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';
import _ from 'lodash';
import { useEffect } from 'react';
import { FormLabelText } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { CategoryTypeList } from '../../../../utils/enum';
import {
  TextAreaInput,
  TextInput,
} from '../../MapPage/FacilityFormPage/CommonForm';
import MarkerImageInput from '../MarkerImageInput';
import { FacilitySelect } from '../../../../components/select/SelectList';

export function EditTypeForm({ form, categoryId }: any) {
  const [getCategoryResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/category/${categoryId}`,
    },
    { manual: false },
  );
  const category = _.get(getCategoryResult, 'response.data');
  const setValue = form.setValue;

  useEffect(() => {
    if (category) {
      setValue('title', category?.title);
      setValue('categoryType', category?.categoryType);
      setValue('notes', category?.notes);
      setValue('iconUrl', category?.iconUrl);
    }
  }, [category, setValue]);

  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="구분"
          fieldPath="title"
          placeholder="예시 : 수영장"
        />
      </Stack>
      <Stack>
        <FormLabelText>
          구분 종류<span>*</span>
        </FormLabelText>
        <RadioGroup row value={CategoryTypeList.REGULAR}>
          <FormControlLabel
            defaultChecked={true}
            value={CategoryTypeList.REGULAR}
            control={<Radio size="small" />}
            label="그 외 시설"
          />
        </RadioGroup>
      </Stack>
      <Stack>
        <FormLabelText>마커 이미지</FormLabelText>
        <MarkerImageInput form={form} />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="notes"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}

export function EditSportingForm({ form, subcategoryId }: any) {
  const { errors, touchedFields: touched } = form.formState;
  const [getSportingResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/subcategory/${subcategoryId}`,
    },
    { manual: false },
  );
  const sporting = _.get(getSportingResult, 'response.data');

  const setValue = form.setValue;
  useEffect(() => {
    if (sporting) {
      setValue('title', sporting?.title);
      setValue('subCategoryType', sporting?.subCategoryType);
      setValue('notes', sporting?.notes);
      setValue('categoryId', sporting?.categoryId);
    }
  }, [sporting, setValue]);
  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="운동기구명"
          fieldPath="title"
          placeholder="예시 : 윗몸일으키기 + 팔굽혀펴기"
        />
      </Stack>
      <Stack>
        <FormLabelText>
          기구 분류<span>*</span>
        </FormLabelText>
        <FacilitySelect
          value={form.watch('subCategoryType')}
          onChange={(e: any) =>
            form.setValue('subCategoryType', e.target.value)
          }
          formControlProps={{
            error: Boolean(touched.subCategoryType && errors.subCategoryType),
          }}
          helperText={_.get(errors, 'subCategoryType.message') as string}
        />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="notes"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}

export function EditStatusForm({ form, statusId }: any) {
  const [getStatusResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/inspectionResultType/${statusId}/`,
    },
    { manual: false },
  );
  const status = _.get(getStatusResult, 'response.data');

  const setValue = form.setValue;
  useEffect(() => {
    if (status) {
      setValue('title', status?.title);
      setValue('inspectionResultTypeId', status?.inspectionResultTypeId);
      setValue('notes', status?.notes);
    }
  }, [status, setValue]);
  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="상태명"
          fieldPath="title"
          placeholder="예시 : 부품파손"
        />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="notes"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}

export function EditDepartmentForm({ form, departmentId }: any) {
  const [getDepartmentResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/department/${departmentId}/`,
    },
    { manual: false },
  );
  const department = _.get(getDepartmentResult, 'response.data');

  const setValue = form.setValue;
  useEffect(() => {
    if (department) {
      setValue('title', department?.title);
      setValue('description', department?.description);
    }
  }, [department, setValue]);
  return (
    <Stack sx={{ w: '100%' }} spacing={4}>
      <Stack sx={{ flex: 1 }}>
        <TextInput
          form={form}
          isRequired={true}
          label="부서명"
          fieldPath="title"
          placeholder="예시 : 광주 북구청 도로과"
        />
      </Stack>
      <Stack>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="비고"
          fieldPath="description"
          placeholder="예시 : 비고 추가 작성"
        />
      </Stack>
    </Stack>
  );
}
